import {Service} from "@/services/Service";

export class EmpleadoService extends Service {
    constructor(axios) {
        super(axios, "/empleado");
    }

    cargar(params) {
        this.onStart();

        return this.http.post(this.getUrl(['/registro']), params)
            .then((response) => {
                // console.info("----", response.data);
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtener(filtros) {
        this.onStart();

        return this.http.post(this.getUrl(['/obtener']), filtros)
            .then((response) => {
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    activarInactivar(id) {
        this.onStart();

        const params = {
            "id_actual": id,
        }

        return this.http.post(this.getUrl(['/activarInactivar']), params)
            .then((response) => {
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}